<template>
  <template v-if="column.loading">
    <v-skeleton-loader v-for="index in 10" :key="index" type="card" />
  </template>
  <orders-grid-card
    v-for="order in column.orderPreviews"
    v-else
    :key="order.id"
    :order-preview="order"
  />
</template>

<script setup lang="ts">
import OrdersGridCard from '@/modules/order/components/OrdersGridCard.vue'
import { OrderPreviewColumn } from '@/modules/order/types'
import { PropType } from 'vue'

defineProps({
  column: {
    type: Object as PropType<OrderPreviewColumn>,
    required: true
  }
})
</script>
